import React from 'react';
import './Transformation.css';

const Transformation = () => {
  return (
    <section className="transformation section">
      <div className="transformation-bg"></div>
      <div className="container">
        <div className="transformation-content">
          <div className="transformation-text">
            <h2 className="transformation-title">
              ТВОЯ ТРАНСФОРМАЦИЯ<br/>
              <span className="highlight">НАЧИНАЕТСЯ СЕГОДНЯ</span>
            </h2>
            <div className="transformation-points">
              <div className="point">
                <div className="point-icon">✓</div>
                <div className="point-text">
                  <h4>Первая неделя — привыкание</h4>
                  <p>Втягиваешься в ритм, изучаешь технику, тело адаптируется к нагрузкам.</p>
                </div>
              </div>
              <div className="point">
                <div className="point-icon">✓</div>
                <div className="point-text">
                  <h4>Первый месяц — первые результаты</h4>
                  <p>Повышается выносливость, улучшается настроение, появляется тонус мышц.</p>
                </div>
              </div>
              <div className="point">
                <div className="point-icon">✓</div>
                <div className="point-text">
                  <h4>3 месяца — видимые изменения</h4>
                  <p>Зеркало не врет. Рельеф, сила, уверенность. Друзья спрашивают: «Что изменилось?»</p>
                </div>
              </div>
              <div className="point">
                <div className="point-icon">✓</div>
                <div className="point-text">
                  <h4>6 месяцев — новая версия себя</h4>
                  <p>Ты не узнаешь себя на старых фото. Фитнес стал частью жизни, а не обязанностью.</p>
                </div>
              </div>
            </div>
            <div className="transformation-cta">
              <a href="#pricing" className="btn-primary">Я Готов Измениться</a>
            </div>
          </div>
          <div className="transformation-visual">
            <div className="visual-card">
              <img
                src="https://images.unsplash.com/photo-1583454110551-21f2fa2afe61?w=600&q=80"
                alt="Transformation"
                className="visual-image"
              />
              <div className="visual-overlay">
                <div className="visual-stats">
                  <div className="visual-stat">
                    <span className="stat-value">-15</span>
                    <span className="stat-label">кг жира</span>
                  </div>
                  <div className="visual-stat">
                    <span className="stat-value">+8</span>
                    <span className="stat-label">кг мышц</span>
                  </div>
                  <div className="visual-stat">
                    <span className="stat-value">100%</span>
                    <span className="stat-label">уверенности</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="visual-badge">
              <span className="badge-text">РЕАЛЬНЫЙ РЕЗУЛЬТАТ</span>
              <span className="badge-subtext">за 6 месяцев</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Transformation;
